import { NearbyPanel } from "@/components/units/unit/info/NearbyPanel";
import type { UnitGroup } from "@/types";
import { useSmoothScrollIntoView } from "@/hooks/useSmoothScrollIntoView";

interface GridNearbyExpansionProps {
    unitGroup: UnitGroup;
    /** Explicit grid row for placement (1-based). */
    gridRow: number;
    /** Whether the expansion is visually open (controlled by parent for animation). */
    isOpen: boolean;
}

/**
 * Grid layout nearby-units expansion — renders as a sibling of the unit cards
 * in the parent `.unit-table` grid, spanning all columns. Mirrors
 * GridPromoExpansion: the parent controls `isOpen` to drive the CSS
 * expand/collapse transition and delays unmount until the collapse finishes.
 */
export const GridNearbyExpansion = ({
    unitGroup,
    gridRow,
    isOpen,
}: GridNearbyExpansionProps) => {
    const containerRef = useSmoothScrollIntoView<HTMLDivElement>(isOpen);

    return (
        <div
            ref={containerRef}
            className={`unit-item__nearby unit-item__nearby-expanded--grid${isOpen ? " unit-item__nearby-expanded--grid--open" : ""}`}
            id={`nearby-panel-${unitGroup.representative_unit.id}`}
            role="region"
            aria-label="Nearby units"
            style={{ gridRow, gridColumn: "1 / -1" }}
        >
            <NearbyPanel unitGroup={unitGroup} />
        </div>
    );
};
